module.exports = __webpack_public_path__ + "static/media/road.8fe04920.jpg";